import {
  ADD_TO_SELECTION,
  REMOVE_FROM_SELECTION,
  SET_NEW_ORDER,
  SET_AVAILABLE_FIELDS,
  RESET_SELECTED_FIELDS,
  SET_ISDEFAULT_FIELD,
  RESET_VIEW,
} from './actionTypes';

export const addToSelection = addedFields => ({
  type: ADD_TO_SELECTION,
  payload: { addedFields },
});

export const removeFromSelection = (removedFields, NeedRestri = true) => ({
  type: REMOVE_FROM_SELECTION,
  payload: { removedFields, NeedRestri },
});

export const setNewOrder = sortedArray => ({
  type: SET_NEW_ORDER,
  payload: { sortedArray },
});

export const setAvailableFields = (data, NeedRestriction = true) => ({
  type: SET_AVAILABLE_FIELDS,
  payload: { data, NeedRestriction },
});

export const setIsDefaultField = isDefaultField => ({
  type: SET_ISDEFAULT_FIELD,
  payload: { isDefaultField },
});

export const retSelectedFields = () => ({
  type: RESET_SELECTED_FIELDS,
});

export const resetFilterValue = () => ({
  type: RESET_VIEW,
});



// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/components/FieldsSelection/flow/actions.js